<template>
  <div>
    <div v-for="category in categories" class="category">
      <div class="d-flex justify-content-between mb-2 border-bottom">
        <template v-if="editMode[category.id]">
          <form-input
              :label="$t('category name')"
              v-model="editMode[category.id].name"
          />
          <form-select
              :label="$t('parent category')"
              :options="categories"
              option-label-key="name"
              option-valu-key="id"
              v-model="editMode[category.id].parent_id"
          />
        </template>
        <template v-else>{{ category.name }}</template>

        <div>
          <button v-if="editMode[category.id]" type="button"
                  class="btn btn-sm btn-secondary"
                  @click="emitModify(category.id)">
            {{ $t('save') }}
          </button>
          <template v-else>
            <button type="button"
                    class="btn btn-sm btn-secondary"
                    @click="enableEditMode(category.id,category)">
              {{ $t('edit') }}
            </button>
            <button type="button"
                    class="btn btn-sm btn-primary"
                    @click="toggleShowChildFlag(category)">
              {{ $t('add child') }}
            </button>
            <button type="button" class="btn btn-sm btn-danger" @click="$emit('delete', category.id)">
              {{ $t('delete') }}
            </button>
          </template>
        </div>
      </div>
      <div class="d-flex" v-if="showNewChild[category.id]">
        <form-input v-model="childName[category.id]" class="mb-0"/>
        <button type="button"
                class="btn btn-sm btn-success"
                @click="emitAdd(category)">
          {{ $t('add') }}
        </button>
      </div>
      <category-tree :categories="category.children"
                     @delete="$emit('delete', $event)"
                     @add="$emit('add', $event)"
      />
    </div>
  </div>

</template>

<script>
import Vue from 'vue';
import FormInput from "@/components/Form/FormInput";
import FormSelect from "@/components/Form/FormSelect";

export default {
  name: "CategoryTree",
  components: {FormSelect, FormInput},
  props: {
    categories: {type: Array, default: () => []}
  },
  data() {
    return {
      showNewChild: {},
      childName: {},
      editMode: {}
    }
  },
  methods: {
    toggleShowChildFlag(category) {
      Vue.set(this.showNewChild, category.id, !this.showNewChild[category.id])
    },
    emitAdd(category) {
      this.$emit('add', {name: this.childName[category.id], parent_id: category.id})
    },
    enableEditMode(id, cat) {
      Vue.set(this.editMode, id, cat)
    },
    emitModify(id) {
      this.$emit('modify', this.editMode[id]);
      Vue.set(this.editMode, id, undefined)
    }
  }
}
</script>

<style>
.category .category {
  padding-left: 10px
}
</style>
